import React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as S from './styles';

interface TabItemProps {
  value: string;
  label: string;
  count?: number;
}

interface TabsProps extends React.ComponentProps<typeof S.TabsRoot> {
  items?: TabItemProps[];
  // eslint-disable-next-line no-unused-vars
  onValueChange?: (value: string) => void;
  defaultValue?: string;
}

export function Tabs({ children, items, onValueChange, defaultValue, ...props }: TabsProps) {
  return (
    <S.TabsRoot {...props} defaultValue={defaultValue} onValueChange={onValueChange}>
      {items ? (
        <>
          <S.TabsList aria-label="Manage boletos">
            {items.map((item) => (
              <S.TabsTrigger key={item.value} value={item.value}>
                {item.label} {item.count !== undefined && `(${item.count})`}
              </S.TabsTrigger>
            ))}
          </S.TabsList>
          {children}
        </>
      ) : (
        children
      )}
    </S.TabsRoot>
  )
}

export function TabsContent({ children, ...props }: TabsPrimitive.TabsContentProps & React.ComponentProps<typeof S.TabsContent>) {
  return (
    <S.TabsContent {...props}>{children}</S.TabsContent>
  )
}

export const TabsList = S.TabsList;
TabsList.displayName = 'TabsList';

export const TabsTrigger = S.TabsTrigger;
TabsTrigger.displayName = 'TabsTrigger';

